const getters = {
  getTheme(state) {
    return state.theme;
  },
};

export { getters as default };
